// The colours of the capability map. An effect area has one colour, in which
// its region, its dots and its lines are drawn, so that a line that leaves a
// region says where it goes. Amber is kept for what is stated as a need and
// white for the selection, so neither is among them. The colours come from the
// theme's chart palette: `categorical` for the areas, `neutral` for the grey.

import type { ChartPalette } from "../../../theme";
import { UNFILED_ID } from "./capabilityMapLayout";

// The place of an area on the curated list: the `top.N` its id ends in. An
// area keeps its colour whatever the scope holds. `top.1` is Sense & inform,
// `top.2` Command, communicate & compute, `top.3` Move & position, `top.4`
// Engage & affect, `top.5` Protect & withstand, `top.6` Produce & transform,
// `top.7` Sustain & serve; each takes the colour at the index before it.
const PLACE = /^top\.([1-9]\d*)$/;

// The place of an area on the list, as its id ends: "top.1" of
// "backbone:capability_part:top.1"
const placeOf = (regionId: string): string =>
  regionId.slice(regionId.lastIndexOf(":") + 1);

// The colour of a region, by the id the layout gives it. An area the list
// does not name takes one of the colours by its id, the same one every time.
export const areaColourOf = (regionId: string, chart: ChartPalette): string => {
  const place = placeOf(regionId);
  if (regionId === UNFILED_ID || place === "top.0") {
    return chart.neutral;
  }
  const index = Number(PLACE.exec(place)?.[1]) - 1;
  const named = chart.categorical[index];
  if (named) {
    return named;
  }
  let sum = 0;
  for (let at = 0; at < regionId.length; at += 1) {
    sum = (sum * 31 + regionId.charCodeAt(at)) % 9973;
  }
  return chart.categorical[sum % chart.categorical.length];
};
